import React, { useState } from 'react';

// COMPONETS
import { HamburgerButton } from '../HamburgerButton';
import SubMenuMobile from './SubMenuMobile';

// ENUMS
import { Icons } from '../../enums/icons';

// ICONS
import Icon from '../Icon/Icon';

// INTERFACE
import { IMenuMobile } from '../../interfaces/MenuMobile.interface';
import { IMenuItemProps } from '../../interfaces/IMenuItem.interface';

// STYLES
import { Divider, MobileMenuFooter, MobileMenuItens, MobileMenuItemHeader, MobileMenuWrapper } from './style';

const MenuMobile: React.FC<IMenuMobile> = ({ itemsMenu, logout }: IMenuMobile) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [subMenuItems, setSubMenuItems] = useState<IMenuItemProps>();

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handClickItem = (item: IMenuItemProps) => {
    if (item.subItems?.length > 0) {
      setSubMenuItems(item);
      setShowSubMenu(true);
      return;
    }

    closeMenu();
  };

  const renderMenuItens = () => {
    return itemsMenu?.map((item: IMenuItemProps, index: number) => {
      const ItemMenu = item.itemMenu;
      return (
        <MobileMenuItemHeader key={index} onClick={() => handClickItem(item)}>
          <ItemMenu />
        </MobileMenuItemHeader>
      );
    });
  };

  return (
    <>
      <HamburgerButton isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
      <MobileMenuWrapper isOpen={isOpen}>
        <MobileMenuItens>
          {!showSubMenu && renderMenuItens()}
          {showSubMenu && (
            <SubMenuMobile backMenu={() => setShowSubMenu(false)} closeMenu={closeMenu} itemMenu={subMenuItems} />
          )}
        </MobileMenuItens>
        <Divider />
        <MobileMenuFooter>
          <a onClick={logout}>
            <Icon type={Icons.LOGOUT} />
            Logout
          </a>
        </MobileMenuFooter>
      </MobileMenuWrapper>
    </>
  );
};

export default MenuMobile;
